import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

import iconSprite from "../../../assets/icon-sprite.svg";
import AxiosClient from "../../utils/AxiosClient";

class OnboardCAC extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOnSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    const { file } = this.state;
    const { data, onClose, documents } = this.props;
    formData.append("file", file, file.name);
    this.setState({ loading: "Uploading File..." }, async () => {
      try {
        const client = await AxiosClient();
        const upload = (await client.post("/util/upload/photo", formData))
          ?.data;
        if (!upload.success) throw new Error(upload.message);

        let response;
        console.log(upload);
        const exists = documents.find(
          ({ type_id }) => +type_id === +data.type_id
        );
        if (exists) {
          response = (
            await client.put("/settings/document/" + exists.id, {
              url: upload.data.url,
              type_id: data.id,
            })
          )?.data;
        } else {
          response = (
            await client.post("/settings/document", {
              url: upload.data.url,
              type_id: data.id,
            })
          )?.data;
        }
        if (response.status !== "success") throw new Error(response?.message);
        toast.success(response?.message);
        onClose?.();
      } catch (error) {
        toast.error(
          error.response?.data?.message ||
            error.message ||
            "Seems like something went wrong with your request. Please try again."
        );
      } finally {
        this.setState({ loading: false });
      }
    });
  };

  render() {
    const { visible, onClose = function $() {}, data = {} } = this.props;
    const { file, loading } = this.state;

    return (
      <Modal className="modal fade" centered show={visible} onHide={onClose}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Upload your {data?.code_description}
            </h5>
            <button type="button" className="close" onClick={onClose}>
              <svg width="48" height="48">
                <use xlinkHref={iconSprite + "#close-icon"}></use>
              </svg>
            </button>
          </div>
          <div className="modal-body">
            <form
              action=""
              className="modal-form"
              onDrop={(e) => {
                e.preventDefault();
                if (
                  e.dataTransfer.items &&
                  e.dataTransfer.items[0].kind === "file"
                ) {
                  const file = e.dataTransfer.items[0].getAsFile();
                  this.setState({ file });
                } else {
                  const file = e.dataTransfer.files[0];
                  this.setState({ file });
                }
              }}
              onDragOver={(e) => e.preventDefault()}
              onSubmit={this.handleOnSubmit}
            >
              <div className="form-group upload-btn">
                <input
                  type="file"
                  className="form-control-file"
                  id="uploadDocument"
                  ref={(fileInput) => {
                    this.fileInput = fileInput;
                  }}
                  onChange={(e) => {
                    this.setState({ file: e.target.files?.[0] });
                  }}
                  accept=".pdf, .png, .jpeg, .jpg"
                />
                <div className="label" htmlFor="uploadDocument" hidden={!!file}>
                  <div className="icon-upload">
                    <svg width="48" height="48">
                      <use xlinkHref={iconSprite + "#image"}></use>
                    </svg>
                  </div>
                  <div className="upload-text">
                    <div className="top">
                      <h3>Drag and drop your file</h3>
                      <p>
                        or{" "}
                        <Link to="#" onClick={() => this.fileInput.click()}>
                          browse
                        </Link>{" "}
                        to choose.
                      </p>
                    </div>
                    <div className="down">
                      <p>(file should be at most 4MB in size.)</p>
                    </div>
                  </div>
                </div>
                <div className="successUpload" hidden={!file}>
                  <div className="btn-wrapper">
                    <button
                      type="button"
                      className="btn btn-link text-danger"
                      onClick={() => {
                        this.fileInput.value = null;
                        this.setState({ file: null });
                      }}
                    >
                      Remove
                    </button>
                  </div>
                  <div className="file">
                    <div className="file--wrapper">
                      <div className="file-icon">
                        <svg width="32" height="32">
                          <use xlinkHref={iconSprite + "#file"}></use>
                        </svg>
                      </div>
                      <div>
                        <p className="name">{file?.name}</p>
                        <p className="size">{file?.size}b</p>
                      </div>
                    </div>
                    <div className="file-status">
                      <svg width="24" height="24">
                        <use xlinkHref={iconSprite + "#done"}></use>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tips">
                <p>**File can be PNG or JPEG.</p>
              </div>
              <div className="modal-footer">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={!!loading}
                >
                  {loading || "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    );
  }
}

export default OnboardCAC;
